// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1T7K3","description":"PatientConsentPreview_description__3rr6K"};